import type { ContentVariant } from './content-variant';
import type { TemplateVersion } from './template';
import type { CreativeVariant } from './variant';

export interface Creative {
    id: number;
    name: string;
    uuid: string;
    templateName: string;
    templateVersion: TemplateVersion;
    templateId: number;
    createdBy: number;
    assetsCount: number;
}

export interface CreativeDetails extends Creative {
    creativeVariants: CreativeVariant[];
    contentVariants: ContentVariant[];
    shouldReconcile: boolean;
}

export interface CreativeListResponse {
    count: number;
    totalCount: number;
    draftCount: number;
    exportCount: number;
    next: string | null;
    previous: string | null;
    results: Creative[];
}

export interface CreativeQuery {
    draft?: boolean;
}
